/** The account's switched-on features (keys). A response without the list reads as none. */
export async function getAccountFeatures(client, accountId) {
    const res = await client.get(`/accounts/${encodeURIComponent(accountId)}/features`);
    if (!res.success)
        throw new Error(res.error || 'Failed to load account features');
    return Array.isArray(res.data?.features) ? res.data.features : [];
}
/** Switches one feature on or off for the account. */
export async function setAccountFeature(client, accountId, key, enabled) {
    const res = await client.put(`/accounts/${encodeURIComponent(accountId)}/features/${encodeURIComponent(key)}`, { enabled });
    if (!res.success)
        throw new Error(res.error || 'Failed to change the setting');
}
